import { Record } from 'immutable';
import { convertRawValues } from '../lib/utils/record_utils';

export default class PaymentPlanRecord extends Record({
  id: null,
  _type: '',
  amount: '',
  name: '',
  installments: '',
  disbursement_date: '',
  interest_fee_percent: '',
  interest_free_intervals: '',
  order_key: '',
  key: null,
  is_past_due: false,
  nsf_count: '',
  last_past_due_at: null,
  merchant_fee_amount: '',
  merchant_fee_percent: '',
  processing_fee_percent: '',
  settled_amount: '',
  payoff_balance: '',
  past_due_count: '',
  total_amount_refunded: '',
  last_payment_attempted_at: '',
  next_payment_due_date: '',
  next_payment_due_amount: '',
  payment_schedule: [],
  transaction_entries: [],
}) {
  constructor(data) {
    data = convertRawValues(data);
    super(data);
  }

  get capture_date() {
    return this.disbursement_date;
  }
}
